module.exports = __webpack_public_path__ + "img/content1-5.b9261e54.webp";